import styled, { css } from 'styled-components'
import { typoHeading5 } from '../../../lib/styles/Typography'
import { IconWrapperProps } from './types'

export const Wrapper = styled.div`
  width: 100%;
`
export const Header = styled.div`
  margin-bottom: 1.5rem;
`

export const HeaderRow = styled.div`
  align-items: center;
  display: flex;
  flex-grow: 0;
  gap: 1rem;
`

export const IconImage = styled.img`
  aspect-ratio: 1/1;
  object-fit: contain;
  width: 100%;
  height: 100%;
`

export const TextContent = styled.div`
  flex: 1 1 auto;
`

export const Name = styled.h5`
  ${typoHeading5}
  margin: 0;
`

export const Position = styled.div`
  color: ${p => p.theme.colors.black[3]};
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.1;
  margin-top: 0.25rem;
`

export const Text = styled.div`
  flex-grow: 1;
  &:before,
  &:after {
    content: '"';
  }
`
export const IconWrapper = styled.div<IconWrapperProps>`
  border-radius: ${({ $hasRoundImage }) => ($hasRoundImage ? '50%' : 'unset')};
  overflow: hidden;
  flex: 0 0 auto;
  width: 2.5rem;
  height: 2.5rem;
  ${({ $hasRoundImage }) =>
    $hasRoundImage &&
    css`
      & img {
        object-fit: cover;
        //transform: scale(1.1);
      }
    `}
`
